export default "__VITE_ASSET__BgfCe1XV__"